import { colors } from "../../ui/colors";

// Base theme = structural + default visual decisions
// Proposals will override parts of this object

const baseSidebarTheme = {
  /* =========================
   * DRAWER
   * ========================= */
  Drawer: {
    background: "var(--fx-surface-sunken, #F8FAFC)",
    border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), .06)",
    shadow: "0 2px 6px rgba(12,12,12,.06)",

    scrollbar: {
      thumb: colors.gray[100],
    },
  },

  /* =========================
   * PAGE ITEM (MAIN NAV ITEMS)
   * ========================= */
  PageItem: {
    background: {
      default: "var(--fx-surface-base, #FFFFFF)",
      hover: "var(--fx-surface-base, #FFFFFF)",
      active: colors.orange[50],
    },

    text: {
      default: colors.gray.base,
      active: colors.orange[600],
    },

    icon: {
      default: colors.gray.base,
      active: colors.orange[600],
    },

    shadow: {
      default: "0 2px 6px rgba(12,12,12,.06)",
      hover: "0 8px 24px rgba(12,12,12,.12)",
      active: "0 8px 24px rgba(12,12,12,.12)",
    },

    indicator: {
      width: 4,
      gradient: `linear-gradient(180deg, ${colors.orange[400]}, #fbbf24)`,
    },
  },

  /* =========================
   * TOOLKIT SECTION (CONTAINER)
   * ========================= */
  ToolkitSection: {
    background: "var(--fx-surface-base, #FFFFFF)",
  },

  /* =========================
   * TOOLKIT ITEM (ROW)
   * ========================= */
  ToolkitItem: {
    shadow: {
      hover: "0 8px 24px rgba(12,12,12,.12)",
    },
    lift: {
      hover: "-1px",
    },
  },

  /* =========================
   * TOOLKIT ICON (ICON BOX)
   * ========================= */
  ToolkitIcon: {
    background: "var(--fx-surface-sunken, #F8FAFC)",
    border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), .06)",
    shadow: "0 2px 6px rgba(12,12,12,.06)",

    icon: {
      default: colors.gray.base,
      hover: colors.gray.base, // proposals may override
    },
  },
};

export default baseSidebarTheme;
